import axios from 'axios'
import SiteConfig from './positiva'
import store from '@/store'

let config = {
  baseURL: SiteConfig.BASE_URL,
  timeout: 20000
}

const Repository = {
  public() {
    return axios.create(config)
  },
  private() {
    config['headers'] = {
      'Authorization': `Token ${store.state.auth.token}`,
      'Content-Type': 'application/json'
    }
    return axios.create(config)
  }
}

export default Repository
